import mapMarkerIconFactory from "../../../../common/components/map/marker/map-marker-icon.factory";
import MapMarker from "../../../../common/components/map/types/map-marker";
import {
  OrderCargoOrderActiveListItem,
  OrderCargoOrderActiveListItemExecutionStatus,
} from "../../../../common/services/order/cargo-order/active-list/order-cargo-order-active-list";
import dateService from "../../../../common/utils/date/date.service";
import orderRoutesHelper from "../../common/routes/order-routes.helper";
import OrderActiveListingFilter from "../common/types/order-active-listing-filter";
import OrderActiveListingFilterType from "../common/types/order-active-listing-filter-type";
import OrderActiveListingOrderStartPoint from "../common/types/order-active-listing-order-start-point";

const msInHour = 3600000;

const createFilteredStartPoint = (
  item: OrderCargoOrderActiveListItem,
): OrderActiveListingOrderStartPoint => {
  const startPointWaypoint = item.routeAddresses[0];
  let startPointName: string;

  if (Array.isArray(startPointWaypoint)) {
    startPointName = startPointWaypoint[0];
  } else {
    startPointName = startPointWaypoint;
  }

  const startPoint: OrderActiveListingOrderStartPoint = {
    lat: item.startLat,
    lon: item.startLon,
    date: item.estimatedStartDate,
    orderHumanId: item.internalOrderId,
    name: startPointName,
  };

  return startPoint;
};

const createFilteredStartPoints = (
  items: OrderCargoOrderActiveListItem[],
  timeFilteringEnabled: boolean,
  filterValue: number,
): OrderActiveListingOrderStartPoint[] => {
  const now = new Date();

  const statusFilteredPoints = items
    .filter((item) => {
      return [
        OrderCargoOrderActiveListItemExecutionStatus.ACCEPTED,
        OrderCargoOrderActiveListItemExecutionStatus.PLANNED,
        OrderCargoOrderActiveListItemExecutionStatus.PENDING,
      ].includes(item.executionStatus);
    })
    .filter((item) => item.estimatedStartDate >= now)
    .map(createFilteredStartPoint);

  if (timeFilteringEnabled) {
    const nowTime = now.getTime();

    const valueFilteredPoints = statusFilteredPoints.filter((point) => {
      return point.date.getTime() - nowTime <= filterValue * msInHour;
    });

    return valueFilteredPoints;
  }

  return statusFilteredPoints;
};

const createMapMarker = (
  point: OrderActiveListingOrderStartPoint,
  tooltipAddressTemplate: string,
  tooltipDateTemplate: string,
): MapMarker => {
  return {
    coordinate: {
      latitude: point.lat,
      longitude: point.lon,
    },
    tooltip: (
      <>
        <div>
          {tooltipDateTemplate.replace(
            "${date}",
            dateService.formatDateTime(point.date),
          )}
        </div>
        <div>{tooltipAddressTemplate.replace("${address}", point.name)}</div>
      </>
    ),
    icon: mapMarkerIconFactory.createStandardIcon({
      content: `${point.orderHumanId}`,
    }),
    onClick: () => {
      window.open(
        orderRoutesHelper.getListingOfActiveOrdersRoute({
          internalOrderId: `${point.orderHumanId}`,
        }),
        "_blank",
      );
    },
  };
};

const createMapMarkers = (
  points: OrderActiveListingOrderStartPoint[],
  tooltipAddressTemplate: string,
  tooltipDateTemplate: string,
): MapMarker[] => {
  return points.map((item) =>
    createMapMarker(item, tooltipAddressTemplate, tooltipDateTemplate),
  );
};

const isMapButtonDisabled = (filters: OrderActiveListingFilter[]): boolean => {
  const filter = filters.find(
    (filter) => filter.type === OrderActiveListingFilterType.EXECUTION_STATUS,
  );

  if (!filter) return false;

  return ![
    OrderCargoOrderActiveListItemExecutionStatus.ACCEPTED,
    OrderCargoOrderActiveListItemExecutionStatus.PLANNED,
    OrderCargoOrderActiveListItemExecutionStatus.PENDING,
  ].includes(filter.value);
};

const orderActiveListingStartPointsMapModalHelper = {
  createFilteredStartPoints,
  createMapMarkers,
  isMapButtonDisabled,
};

export default orderActiveListingStartPointsMapModalHelper;
